import { render, staticRenderFns } from "./fahuo.vue?vue&type=template&id=925e0ed8&"
import script from "./fahuo.vue?vue&type=script&lang=js&"
export * from "./fahuo.vue?vue&type=script&lang=js&"
import style0 from "./fahuo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports